import { Component, OnInit , Input, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-order',
  templateUrl: './confirm-order.component.html',
  styleUrls: ['./confirm-order.component.scss']
})
export class ConfirmOrderComponent implements OnInit {
  message: any;

 

  constructor( public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    console.log(this.data)
    this.message = this.data.message
  }

  closeImg(btn?){
    console.log('closed')
    if(btn=== 'swap'){
      this.dialogRef.close({result:btn});
    }
    else if(btn === 'ok'){
      this.dialogRef.close({result:btn});

    }
    else{
      this.dialogRef.close();
    }
    


  }


}
